var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRalvieLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202.523,
    height: 53.5,
    viewBox: "0 0 202.523 53.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.977,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#814d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d0b77"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ralvie_Logo",
    "data-name": "ralvie Logo",
    transform: "translate(-407.178 -362.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_105",
    "data-name": "Subtraction 105",
    d: "M23.524,53.5h0Zm-1.864-.072h0a23.535,23.535,0,0,1-18-10.691,23.048,23.048,0,0,1-1.977-3.8A22.772,22.772,0,0,1,0,30.317,23.029,23.029,0,0,1,.466,25.7,22.769,22.769,0,0,1,1.8,21.4H16.287a5.351,5.351,0,1,1,0,10.7H5.92l3.341,4.527,1.923,2.607L21.661,53.428Zm6.9-.46h0L18.307,39.077a12.73,12.73,0,0,0,2.909-.825,12.565,12.565,0,0,0,4.026-2.675,12.4,12.4,0,0,0,2.715-3.967,12.36,12.36,0,0,0,0-9.718,12.422,12.422,0,0,0-2.715-3.968,12.606,12.606,0,0,0-4.026-2.676,12.738,12.738,0,0,0-4.929-.98H6.548A23.579,23.579,0,0,1,18.659,7.63,24.082,24.082,0,0,1,28.265,7.6a23.584,23.584,0,0,1,11.893,6.319,23.4,23.4,0,0,1,2.873,3.431A23.033,23.033,0,0,1,45.2,21.293a22.913,22.913,0,0,1-3.431,23.66,23.578,23.578,0,0,1-13.21,8.015ZM26.238,5.35H20.809a2.716,2.716,0,0,1-1.919-.784,2.648,2.648,0,0,1,0-3.783A2.717,2.717,0,0,1,20.809,0h5.429a2.717,2.717,0,0,1,1.92.783,2.648,2.648,0,0,1,0,3.783A2.716,2.716,0,0,1,26.238,5.35Z",
    transform: "translate(407.178 362.997)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_407",
    "data-name": "Union 407",
    d: "M0,39.024V11.057H4.984v4.6a11.27,11.27,0,0,1,9.854-5.447v4.83a4.434,4.434,0,0,0-.86-.056c-5.442.169-8.994,3.707-8.994,9.21V39.024ZM111.829,24.08c0-8.548,6.121-14.945,14.552-14.945,8.835,0,13.975,6.793,13.975,13.982a11.778,11.778,0,0,1-.173,2.434H116.507c.693,6.623,5.6,9.4,10.394,9.4a9.591,9.591,0,0,0,8.373-4.359l3.58,2.378c-2.656,4.076-7.044,6.057-12.011,6.057C117.893,39.024,111.829,32.74,111.829,24.08Zm4.793-2.321h19.115c-.462-4.415-3.638-8.6-9.3-8.6A9.918,9.918,0,0,0,116.622,21.759ZM100.344,39.024V10.833h5.024v28.19ZM65.434,9.7h5.255L80.622,30.08,90.5,9.7h5.2L80.564,39.024ZM55.876,39.024V0H60.91V39.024Zm-13.718,0v-6.4a12.722,12.722,0,0,1-11.2,6.4A14.4,14.4,0,0,1,16.286,24.193c0-8.661,6.352-15.057,14.841-15.057a12.388,12.388,0,0,1,11.087,6.453L47.007,8.4V39.024ZM21.31,24.136A10.1,10.1,0,0,0,31.7,34.552a10.473,10.473,0,1,0,.116-20.944A10.216,10.216,0,0,0,21.31,24.136ZM99.132,3.68a3.7,3.7,0,0,1,3.7-3.68,3.785,3.785,0,0,1,3.754,3.68A3.776,3.776,0,0,1,102.828,7.3,3.649,3.649,0,0,1,99.132,3.68Z",
    transform: "translate(469.345 370.595)",
    fill: "#1d0b77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalvieLogo);
export default __webpack_public_path__ + "static/media/RalvieLogo.bed2b4e5817ba78df8eb21ed75d24ec3.svg";
export { ForwardRef as ReactComponent };